import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as R from 'ramda';

// Prevent re-render due to use state change cause by useMemo hook
const CardoContainer = React.memo(({
  childComponent: ChildComponent,
  ...props
}) => (
  <ChildComponent
    {...props}
  />
));

const getCardoData = ({ content, data }) => {
  if (typeof data === 'string') {
    // Fetch from the redux store
    return R.pathOr({}, ['cardo', data])(content);
  }

  // Else assume the Cardo data is supplied as a prop
  return data;
};

const mapStateToProps = ({ content, breakpoints = {}, location }, { data }) => ({
  data: getCardoData({ content, data }),
  currentBreakpoint: breakpoints.current,
  originUrl: R.prop('origin')(location),
});

const mapDispatchToProps = {};

CardoContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CardoContainer);
